.container {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.label {
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: var(--color-grayscale-trout);
}

.root {
  position: relative;
  overflow: hidden;
  background: var(--color-grayscale-tuna);
  border-radius: 0.8rem;
  width: 100%;
  height: 0.4rem;

  /* Fix overflow clipping in Safari */
  /* https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0 */
  transform: translateZ(0);
}

.indicator {
  background-color: var(--color-primary-telemagenta);
  width: 100%;
  height: 100%;
  transition: transform 660ms cubic-bezier(0.65, 0, 0.35, 1);
}
